import { useMutation, useQueryClient } from '@tanstack/react-query';
import { MutationKey } from 'core/react-query/queryClient';
import { boxInvitationsQuery } from 'networking/mindfeed/queries/boxInvitations';
import { notify, NotificationType } from 'xstate/actors/NotificationActor';
import {
  createBoxInvitation,
  type CreateBoxInvitationPayload,
} from 'networking/mindfeed/services/box.service';
import { BoxId } from 'models/Box';
import { InvitationLink } from 'models/Invitation';

type Variables = {
  boxId: BoxId;
  payload: CreateBoxInvitationPayload;
};

const useCreateBoxInvitation = () => {
  const queryClient = useQueryClient();

  const onSuccessCallback = async (
    _data: InvitationLink,
    variables: Variables,
  ) => {
    // Invalidate invitations. Unecessary for link invitations.
    if (variables.payload.method != 'link') {
      queryClient.invalidateQueries({
        queryKey: boxInvitationsQuery(variables.boxId).queryKey,
      });
    }

    // Notify User
    notify(NotificationType.BOX_INVITATION_CREATED);
  };

  return useMutation<InvitationLink, Error, Variables>({
    mutationKey: [MutationKey.CREATE_BOX_INVITATION],
    mutationFn: (variables) =>
      createBoxInvitation(variables.boxId, variables.payload),
    onSuccess: onSuccessCallback,
  });
};

export default useCreateBoxInvitation;
